import script from "./ProductCategoriesField.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCategoriesField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__